import React from "react";

export default (props) => {
    
    const {
        handleOnChange,
        fieldName,
        value,
        label,
        formEdit,
    } = props;
    
    return (
            <div
                className={formEdit ? "checkboxes checkboxes_align-left" : "checkboxes checkboxes_align-left disabled"}
                >
                <label
                    className="c-form__label"
                    htmlFor={fieldName}
                    >
                    <label className="custom-radio">
                        <input
                            disabled={formEdit ? false : true}
                            checked={value}
                            className="value"
                            type="checkbox"
                            id={fieldName}
                            onChange={(e) => handleOnChange(value ? false : true, fieldName)}
                            />
                        <div></div>
                    </label>
                    <span className="text">{label}</span>
                </label>
            </div>
        )
}


// WEBPACK FOOTER //
// ./src/components/Account/NotificaionsFormCheckbox.js